/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GraduatedPrice } from './GraduatedPrice';
import {
    GraduatedPriceFromJSON,
    GraduatedPriceFromJSONTyped,
    GraduatedPriceToJSON,
} from './GraduatedPrice';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { Pricing } from './Pricing';
import {
    PricingFromJSON,
    PricingFromJSONTyped,
    PricingToJSON,
} from './Pricing';
import type { ThresholdPrice } from './ThresholdPrice';
import {
    ThresholdPriceFromJSON,
    ThresholdPriceFromJSONTyped,
    ThresholdPriceToJSON,
} from './ThresholdPrice';

/**
 * 
 * @export
 * @interface EnterprisePrice
 */
export interface EnterprisePrice {
    /**
     * 
     * @type {Pricing}
     * @memberof EnterprisePrice
     */
    pricing?: Pricing;
    /**
     * 
     * @type {Price}
     * @memberof EnterprisePrice
     */
    price?: Price;
    /**
     * 
     * @type {Array<GraduatedPrice>}
     * @memberof EnterprisePrice
     */
    graduatedPrices?: Array<GraduatedPrice>;
    /**
     * 
     * @type {Array<ThresholdPrice>}
     * @memberof EnterprisePrice
     */
    thresholdPrices?: Array<ThresholdPrice>;
}

/**
 * Check if a given object implements the EnterprisePrice interface.
 */
export function instanceOfEnterprisePrice(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EnterprisePriceFromJSON(json: any): EnterprisePrice {
    return EnterprisePriceFromJSONTyped(json, false);
}

export function EnterprisePriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnterprisePrice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pricing': !exists(json, 'pricing') ? undefined : PricingFromJSON(json['pricing']),
        'price': !exists(json, 'price') ? undefined : PriceFromJSON(json['price']),
        'graduatedPrices': !exists(json, 'graduatedPrices') ? undefined : ((json['graduatedPrices'] as Array<any>).map(GraduatedPriceFromJSON)),
        'thresholdPrices': !exists(json, 'thresholdPrices') ? undefined : ((json['thresholdPrices'] as Array<any>).map(ThresholdPriceFromJSON)),
    };
}

export function EnterprisePriceToJSON(value?: EnterprisePrice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pricing': PricingToJSON(value.pricing),
        'price': PriceToJSON(value.price),
        'graduatedPrices': value.graduatedPrices === undefined ? undefined : ((value.graduatedPrices as Array<any>).map(GraduatedPriceToJSON)),
        'thresholdPrices': value.thresholdPrices === undefined ? undefined : ((value.thresholdPrices as Array<any>).map(ThresholdPriceToJSON)),
    };
}

